import type { IconData } from '@stacksjs/iconify-core'

export const toiletSignMan: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M18.066 16.215c-1.617.134-2.946 1.2-3.457 2.74a54.3 54.3 0 0 0-2.364 10.684c-.183 1.595 1.012 2.979 2.615 3.08c.644.04 1.384.082 2.207.12l.746 9.326c.11 1.372 1.14 2.494 2.51 2.633c1.06.107 2.368.202 3.677.202s2.618-.095 3.677-.202c1.37-.14 2.4-1.26 2.51-2.633l.746-9.326c.823-.038 1.564-.08 2.208-.12c1.602-.101 2.798-1.485 2.614-3.08a54.3 54.3 0 0 0-2.363-10.684c-.512-1.54-1.841-2.606-3.458-2.74C28.566 16.1 26.616 16 24 16s-4.566.101-5.934.215\"/><path d=\"M17.5 9.5a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0-13 0M24 35v10\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletSignMan
